var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 5.24574C9.82847 5.24574 9.16351 5.37801 8.5431 5.63499C7.92268 5.89198 7.35896 6.26864 6.88411 6.74349C6.40927 7.21833 6.0326 7.78206 5.77562 8.40247C5.51863 9.02289 5.38636 9.68784 5.38636 10.3594C5.38636 11.0309 5.51863 11.6959 5.77562 12.3163C6.0326 12.9367 6.40927 13.5004 6.88411 13.9753C7.35896 14.4501 7.92268 14.8268 8.5431 15.0838C9.16351 15.3407 9.82847 15.473 10.5 15.473C11.8562 15.473 13.1569 14.9343 14.1159 13.9753C15.0749 13.0163 15.6136 11.7156 15.6136 10.3594C15.6136 9.00315 15.0749 7.70248 14.1159 6.74349C13.1569 5.7845 11.8562 5.24574 10.5 5.24574ZM4.25 10.3594C4.25 6.90767 7.0483 4.10938 10.5 4.10938C13.9517 4.10938 16.75 6.90767 16.75 10.3594C16.75 13.8111 13.9517 16.6094 10.5 16.6094C7.0483 16.6094 4.25 13.8111 4.25 10.3594Z",
    fill: "#164B35",
    stroke: "#164B35",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6863 8.65497L9.2965 13.0447L7.09082 10.4124L7.94934 9.66804L9.35616 11.3783L12.8829 7.85156L13.6863 8.65497Z",
    fill: "#164B35",
    stroke: "#164B35",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/present.e7c14b26f4e8bf08b82fbaf6ec8f2bcd.svg";
export { ForwardRef as ReactComponent };